import { gql } from '@apollo/client'
import { BRAND_EXECUTION_FRAGMENT } from '../fragments/BrandExecutionFragment'

export const KEY_ACCOUNT_BRAND_EXECUTION = gql`
  query KeyAccountBrandExecution($input: DXOExecutionForZonePathInput!) {
    keyAccountBrandExecution(input: $input) {
      hasMore
      count
      results {
        ...BrandExecution
      }
    }
  }
  ${BRAND_EXECUTION_FRAGMENT}
`
